<style>
.results-counter {
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 48px;
  padding-right: 1rem;
}
</style>

<template>
  <anchor-right-content container-classes="results-counter subtitle-2">
    {{ text }}
  </anchor-right-content>
</template>

<script>
export default {
  name: 'AnchorResultsDisplay',
  props: {
    text: String,
  },
};
</script>
